import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseAddressyApiService } from './base-addressy-api.service';
import { AddressyResponse } from '../../../interfaces/addressy/api/addressy-api.interface';
import { AddressyItem } from '../../../interfaces/addressy/api/address/retrieve-api.interface';

@Injectable({ providedIn: 'root' })
export class AddressyRetrieveApiService extends BaseAddressyApiService {
  private baseUrl: string = '/retrieve/v1.20';

  getAddressById(id: string): Observable<AddressyResponse<AddressyItem[]>> {
    return this.get(`${this.baseUrl}/json3.ws`, { params: { Id: id } });
  }
}
